<template>
    <div class="planos-container">
    <div class="back-button-top">
      <button class="back-link" @click="prevStep">Voltar</button>
    </div>
    <div class="logo-container">
      <img src="@/assets/img/logo.png" alt="LubConsulta" class="logo">
    </div>
    <div class="wizard narrow-wizard">
      <div class="step" :class="{ 'active': currentStep === 1 }">
        <div class="step-number">1</div>
        <div class="step-info">
          <div class="step-title">Plano Selecionado</div>
          <div class="step-description">Você escolheu o melhor plano para o seu negócio.</div>
        </div>
      </div>
      <div class="step" :class="{ 'active': currentStep === 2 }">
        <div class="step-number">2</div>
        <div class="step-info">
          <div class="step-title">Pagamento</div>
          <div class="step-description">Preencha os dados de pagamento e selecione o tipo de cobrança.</div>
        </div>
      </div>
      <div class="step" :class="{ 'active': currentStep === 3 }">
        <div class="step-number">3</div>
        <div class="step-info">
          <div class="step-title">Assinatura</div>
          <div class="step-description">Parabéns, seu Plano foi registrado com sucesso.</div>
        </div>
      </div>
    </div>
    <div class="step-content narrow-content">
      <!-- Passo 1: Confirmação do Plano Plus -->
      <div v-if="currentStep === 1" class="step-1">
        <h2 class="narrow-title">Confirme seu Plano</h2>
        <p class="subtitle">Você está prestes a assinar o Plano Plus com todos os recursos liberados.</p>

        <div class="plans-container" style="display: flex; justify-content: center;">
          <!-- Card Plano Plus (Ênico nesta página) -->
          <div class="plan-card plus" style="max-width: 450px;">
            <div class="plan-header">
              <h2>Plano Plus</h2>
            </div>
            <div class="plan-pricing">
              <div class="monthly">
                <div class="price">179,90</div>
                <div class="period">ou mês</div>
              </div>
              <div class="yearly">
                <div class="price">1558,80</div>
                <div class="period">por ano em até 6x</div>
              </div>
              <div class="savings2">Economize <strong>R$ 600,00</strong> no pagamento anual.</div>
            </div>
            <div class="plan-features">
              <div class="feature">
                      <svg xmlns="http://www.w3.org/2000/svg" class="icone-svg" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="12" cy="12" r="10" fill="#53b42f" />
                        <path d="M9 12l2 2l4 -4" />
                      </svg> Catálogo completo de lubrificantes e filtros</div>
              <div class="feature">
                      <svg xmlns="http://www.w3.org/2000/svg" class="icone-svg" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="12" cy="12" r="10" fill="#53b42f" />
                        <path d="M9 12l2 2l4 -4" />
                      </svg> Consulta de produtos pela placa do veículo</div>
              <div class="feature">
                      <svg xmlns="http://www.w3.org/2000/svg" class="icone-svg" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="12" cy="12" r="10" fill="#53b42f" />
                        <path d="M9 12l2 2l4 -4" />
                      </svg> Consulta de veículos pelo modelo do veículo</div>
              <div class="feature">
                      <svg xmlns="http://www.w3.org/2000/svg" class="icone-svg" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="12" cy="12" r="10" fill="#53b42f" />
                        <path d="M9 12l2 2l4 -4" />
                      </svg> Download do manual do proprietário</div>
              <div class="feature">
                      <svg xmlns="http://www.w3.org/2000/svg" class="icone-svg" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="12" cy="12" r="10" fill="#53b42f" />
                        <path d="M9 12l2 2l4 -4" />
                      </svg> Ficha técnica de lubrificantes</div>
              <div class="feature">
                      <svg xmlns="http://www.w3.org/2000/svg" class="icone-svg" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="12" cy="12" r="10" fill="#53b42f" />
                        <path d="M9 12l2 2l4 -4" />
                      </svg> Cadastro de clientes</div>
              <div class="feature">
                      <svg xmlns="http://www.w3.org/2000/svg" class="icone-svg" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="12" cy="12" r="10" fill="#53b42f" />
                        <path d="M9 12l2 2l4 -4" />
                      </svg> Registro de serviço de troca de óleo</div>
              <div class="feature">
                      <svg xmlns="http://www.w3.org/2000/svg" class="icone-svg" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="12" cy="12" r="10" fill="#53b42f" />
                        <path d="M9 12l2 2l4 -4" />
                      </svg> Lembrete automático via WhatsApp para a próxima troca de óleo do veículo</div>
            </div>
            <button class="select-button" @click="nextStep">AVANÇAR PARA PAGAMENTO</button>
          </div>
        </div>
      </div>

      <!-- Passo 2: Formulário e OpçÃµes de Pagamento -->
      <div v-if="currentStep === 2" class="step-2">
        <h2 class="narrow-title">Escolha a forma de pagamento</h2>
        <p class="subtitle">Preencha os dados e selecione a modalidade de cobrança do Plano Plus</p>
        
        <div class="plan-card2" style="border: 1px solid #ef8d1e; border-radius: 8px; padding: 15px; margin-bottom: 30px;">                  
          <div class="plan-sub" style="font-weight: bold; text-align: left;">PLANO SELECIONADO</div>
          <div class="plan-name" style="background-color: #ef8d1e; color: white; font-size: 24px; font-weight: bold; border-radius: 5px; padding: 8px; width: 250px; margin-bottom: 5px;">
            Plano Plus
          </div>
          <div class="plan-value" style="margin-bottom: 10px; padding: 5px;">
            <div class="plan-price" style="font-weight: bold; font-size: 18px; color: #666;">
              R$ 179,90 mensal ou R$ 1.558,80 anual em até 6x
            </div>
          </div>
        </div>

        <div class="form-section">
          <h2 class="form-title">Dados do Cliente</h2>
          <div class="form-row">
            <div class="form-group">
              <label class="form-label">CNPJ <span class="required">*</span></label>
              <input type="text" class="form-input" v-model="personalInfo.document" placeholder="00.000.000/0000-00" @input="onCnpjInput" @blur="fetchAndPopulateCustomerData">
            </div>
            <div class="form-group">
              <label class="form-label">Nome Completo / Razão Social <span class="required">*</span></label>
              <input type="text" class="form-input" v-model="personalInfo.fullName" :disabled="fieldStates.fullName" :class="{ 'disabled-field': fieldStates.fullName }">
            </div>
          </div>
          
          <div class="form-row">
            <div class="form-group">
              <label class="form-label">Telefone <span class="required">*</span></label>
              <input ref="phoneInput" type="text" class="form-input" v-model="personalInfo.phone" placeholder="(99) 9 9999-9999" @input="onPhoneInput">
            </div>
            <div class="form-group">
              <label class="form-label">E-mail <span class="required">*</span></label>
              <input ref="emailInput" type="email" class="form-input" v-model="personalInfo.email" placeholder="seu@email.com" @input="checkEmailPattern">
            </div>
          </div>
            
          <div class="form-row">
            <div class="form-group">
              <label class="form-label">Endereço <span class="required">*</span></label>
              <input type="text" class="form-input" v-model="billingAddress.street" :disabled="fieldStates.street" :class="{ 'disabled-field': fieldStates.street }">
            </div>
            <div class="form-group">
              <label class="form-label">CEP <span class="required">*</span></label>
              <input type="text" class="form-input" v-model="billingAddress.zipCode" :disabled="fieldStates.zipCode" :class="{ 'disabled-field': fieldStates.zipCode }">
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label class="form-label">Número <span class="required">*</span></label>
              <input type="text" class="form-input" v-model="billingAddress.number" :disabled="fieldStates.number" :class="{ 'disabled-field': fieldStates.number }">
            </div>
            <div class="form-group">
              <label class="form-label">Bairro</label>
              <input type="text" class="form-input" v-model="billingAddress.bairro" :disabled="fieldStates.bairro" :class="{ 'disabled-field': fieldStates.bairro }">
            </div>
            <div class="form-group">
              <label class="form-label">Complemento</label>
              <input type="text" class="form-input" v-model="billingAddress.complement" :disabled="fieldStates.complement" :class="{ 'disabled-field': fieldStates.complement }">
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label class="form-label">Cidade <span class="required">*</span></label>
              <input type="text" class="form-input" v-model="billingAddress.city" :disabled="fieldStates.city" :class="{ 'disabled-field': fieldStates.city }">
            </div>
            <div class="form-group">
              <label class="form-label">UF <span class="required">*</span></label>
              <input type="text" class="form-input" v-model="billingAddress.state" :disabled="fieldStates.state" :class="{ 'disabled-field': fieldStates.state }">
            </div>
          </div>
        </div>

        <div class="form-section">
          <h2 class="form-title">Forma de pagamento</h2>
          <div class="payment-methods">
            <div class="payment-method" :class="{ active: paymentMethod === 'creditCard' }" @click="paymentMethod = 'creditCard'">
              <strong>Cartão de Crédito</strong> 
              <IconCreditCardFilled stroke={2} style="display: inline-block; vertical-align: middle; margin-left: 5px;" />
            </div>
            <div class="payment-method" :class="{ active: paymentMethod === 'boleto' }" @click="paymentMethod = 'boleto'; valorSelecionado = ''">
              <strong>Boleto</strong> 
              <IconBarcode :stroke="2" style="display: inline-block; vertical-align: middle; margin-left: 5px;" />
            </div>
            <div class="payment-method" :class="{ active: paymentMethod === 'pix' }" @click="paymentMethod = 'pix'; valorSelecionado = ''">
              <strong>Pix</strong> 
              <IconQrcode stroke={2} style="display: inline-block; vertical-align: middle; margin-left: 5px;" />
            </div>
          </div>

          <!-- Formulário Cartão de Crédito - Apenas OpçÃµes PLUS -->
          <div v-if="paymentMethod === 'creditCard'">
            <div class="valor-cobranca" style="margin-bottom: 20px;">
                <label style="font-weight: bold; margin-bottom: 8px; display: block;">Selecione o Parcelamento <span style="color: red;">*</span></label>
                <select
                    v-model="valorSelecionado"
                    class="form-control"
                    style="width: 100%; padding: 12px; border-radius: 25px; border: 1px solid #ccc;"
                    @change="handlePaymentOptionChange"
                >
                    <option value="">Clique para escolher...</option>
                    <option value="plus_monthly">R$ 179,90 mensal (Assinatura)</option>
                    <option value="plus_yearly">R$ 1.558,80 anual à vista</option>
                    <option value="plus_installment_2">Em 2x de R$ 779,40 — Total: R$ 1.558,80 sem juros</option>
                    <option value="plus_installment_3">Em 3x de R$ 519,60 — Total: R$ 1.558,80 sem juros</option>
                    <option value="plus_installment_4">Em 4x de R$ 389,70 — Total: R$ 1.558,80 sem juros</option>
                    <option value="plus_installment_5">Em 5x de R$ 311,76 — Total: R$ 1.558,80 sem juros</option>
                    <option value="plus_installment_6">Em 6x de R$ 259,80 — Total: R$ 1.558,80 sem juros</option>
                    <option value="plus_installment_10">Em 10x de R$ 155,88 — Total: R$ 1.558,80 sem juros</option>
                    <option value="plus_installment_12">Em 12x de R$ 129,90 — Total: R$ 1.558,80 sem juros</option>
                </select>
            </div>
            
            <div class="form-row">
                <div class="form-group">
                <label class="form-label">Número do Cartão <span class="required">*</span></label>
                <input type="text" class="form-input" v-model="creditCard.number" placeholder="0000 0000 0000 0000">
                </div>
                <div class="form-group">
                <label class="form-label">Nome do titular <span class="required">*</span></label>
                <input type="text" class="form-input" v-model="creditCard.holderName" placeholder="Como está no Cartão">
                </div>
            </div>
            <div class="form-row">
                <div class="form-group" style="flex: 0 0 150px;">
                <label class="form-label">Validade <span class="required">*</span></label>
                <input type="text" class="form-input" v-model="creditCard.expiryDate" placeholder="MM/AA">
                </div>
                <div class="form-group" style="flex: 0 0 100px;">
                <label class="form-label">CVV <span class="required">*</span></label>
                <input type="text" class="form-input" v-model="creditCard.cvv" placeholder="000">
                </div>
                <div v-if="valorSelecionado" class="form-group" style="flex: 1; margin-left: 20px;">
                    <label class="form-label">Resumo da cobrança:</label>
                    <div style="font-weight: bold; font-size: 1.1em; padding-top: 5px; color: #ef8d1e;">
                        {{ selectedOptionDescription }} (R$ {{ valorFinalFormatado }}/mês)
                    </div>
                </div>
            </div>
          </div>

          <!-- Boleto Display para PLUS -->
          <div v-if="paymentMethod === 'boleto'" class="boleto-display">
            <div class="valor-cobranca" style="margin-bottom: 20px;">
              <label style="font-weight: bold; margin-bottom: 8px; display: block;">Modalidade de Boleto <span style="color: red;">*</span></label>
              <select v-model="valorSelecionado" class="form-control" style="width: 100%; padding: 12px; border-radius: 25px; border: 1px solid #ccc;" @change="handlePaymentOptionChange">
                <option value="">Selecione...</option>
                <option value="plus_monthly">R$ 179,90 mensal</option>
                <option value="plus_yearly">R$ 1.558,80 anual (com desconto)</option>
              </select>
            </div>
            <div v-show="showBoleto" class="boleto-box" style="border: 1px dashed #ccc; padding: 15px; text-align: center;">
                <p>O boleto foi gerado e enviado para seu e-mail.</p>
                <a :href="dados.linkFatura" target="_blank" class="btn btn-primary" style="display: inline-block; margin-top: 10px;">Visualizar Boleto</a>
            </div>
          </div>

          <!-- Pix Display para PLUS -->
          <div v-if="paymentMethod === 'pix'" class="pix-display">
            <div class="valor-cobranca" style="margin-bottom: 20px;">
              <label style="font-weight: bold; margin-bottom: 8px; display: block;">Modalidade Pix <span style="color: red;">*</span></label>
              <select v-model="valorSelecionado" class="form-control" style="width: 100%; padding: 12px; border-radius: 25px; border: 1px solid #ccc;" @change="handlePaymentOptionChange">
                <option value="">Selecione...</option>
                <option value="plus_monthly">R$ 179,90 mensal</option>
                <option value="plus_yearly">R$ 1.558,80 anual (com desconto)</option>
              </select>
            </div>
            <div v-if="showPixDetails" style="text-align: center;">
              <canvas id="pix-qr" style="margin-bottom: 10px;"></canvas>
              <br>
              <button class="btn btn-secondary copy-btn" @click="copyPixCode">Copiar código Pix</button>
            </div>
          </div>
        </div>

        <div class="navigation-buttons">
          <button class="nav-button btn btn-secondary" @click="prevStep">Voltar</button>
          <button v-if="paymentMethod === 'creditCard' && !isProcessing" class="nav-button btn btn-primary" @click="showConfirmationModal">
            Finalizar Assinatura Plano Plus
          </button>
          <div v-if="isProcessing" class="nav-button btn btn-primary disabled">Processando...</div>
        </div>
      </div>

      <!-- Passo 3: Sucesso -->
      <div v-if="currentStep === 3" class="step-3" style="text-align: center; padding: 40px;">
        <div style="font-size: 60px; color: #53b42f; margin-bottom: 20px;">✓</div>
        <h2>Parabéns! Sua assinatura Plus foi registrada.</h2>
        <p>Enviamos os dados de acesso para o e-mail: <strong>{{ personalInfo.email }}</strong></p>
        <div class="navigation-buttons" style="justify-content: center;">
          <a href="https://app.lubconsulta.com.br" class="nav-button btn btn-primary">Acessar Plataforma Agora</a>
        </div>
      </div>
    </div>

    <footer class="site-footer">@ lubconsuta.com.br</footer>

    <!-- Modais de Suporte -->
    <div v-if="showModal" class="modal-overlay">
        <div class="modal-content">
            <h3 class="modal-title">{{ modalTitle }}</h3>
            <p class="modal-message">{{ modalMessage }}</p>
            <button class="modal-close-btn" @click="closeModal">Fechar</button>
        </div>
    </div>

    <div v-if="showPaymentConfirmationModal" class="modal-overlay">
        <div class="modal-content payment-confirmation-modal">
            <h3 class="modal-title">Confirmar Assinatura Plus</h3>
            <div class="payment-details" style="text-align: left; background: #f9f9f9; padding: 15px; border-radius: 8px;">
                <p><strong>Plano:</strong> Plano Plus</p>
                <p><strong>cobrança:</strong> {{ selectedOptionDescription }}</p>
                <p><strong>Cartão Final:</strong> {{ lastFourDigits }}</p>
                <p><strong>Valor da cobrança:</strong> R$ {{ valorFinalFormatado }}</p>
            </div>
            <div class="modal-actions" style="margin-top: 20px; display: flex; gap: 10px;">
                <button class="btn btn-secondary" style="flex: 1;" @click="cancelPayment">Corrigir</button>
                <button class="btn btn-primary" style="flex: 1;" @click="confirmPayment">Confirmar e Pagar</button>
            </div>
        </div>
    </div>

    <LoadingSpinner :show="showLoadingSpinner" :message="loadingMessage" />
  </div>
</template>


<script>
import QRCode from 'qrcode'
import apiClient from '@/services/api.js'; 
import LoadingSpinner from '@/modules/planos/LoadingSpinner.vue';

export default {
  name: 'PlanoPlusView',
  components: { 
    LoadingSpinner 
  },
  data() {
    return {      
      isSubmittingData: false, 
      paymentMonitorInterval: null, 
      monitorAttempts: 0,           
      maxMonitorAttempts: 100,
      isProcessing: false,
      showModal: false,
      modalTitle: '',
      modalMessage: '',
      paymentSuccessful: false,
      valorSelecionado: '',
      pixCode: '',
      showPixDetails: false,
      currentStep: 1,
      selectedPlan: 'plus',
      showWhatsAppChat: false,
      whatsappMessage: '',
      showBoleto: false,
      showLoadingSpinner: false, 
      showContactAlertModal: false,
      hasShownContactModal: false,
      lastValidatedCnpj: '', 
      loadingMessage: 'Processando...',
      coupon: { code: '', applied: false, discount: 0 },
      couponsList: [
        { "id": "11", "plano": "Plus", "cupon": "PLPROMO10", "percentual": "10" },
        { "id": "12", "plano": "Plus", "cupon": "PLSAVE10", "percentual": "10" },
        { "id": "26", "plano": "Plus", "cupon": "PLPROMO20", "percentual": "20" }
      ],
      billingAddress: {
        street: '', number: '', bairro: '', complement: '', zipCode: '', country: 'Brasil', state: '', city: ''
      },
      fieldStates: {
        document: false, fullName: true, street: true, zipCode: true, number: true, bairro: true, complement: true, country: true, state: true, city: true
      },
      personalInfo: { fullName: '', document: '', phone: '', email: '' },
      validation: { phoneTouched: false, emailTouched: false, phoneValid: true, emailValid: true },
      paymentMethod: 'creditCard',
      creditCard: { number: '', holderName: '', expiryDate: '', cvv: '' },
      dados: {
          beneficiario: 'INOVAUTO INFO STARTUP LTDA', cnpjBeneficiario: '54.126.790/0001-85', vencimento: '', nossoNumero: '', valor: '', netValue: '', descricao: '', linkFatura: '', pagador: '', enderecoPagador: '', invoiceNumber: '', status: ''
      },                  
      linhaDigitavel: '',
      codigoBarras: '',
      qrcodeBase64: '',
      showCoupon: false,
      showPlanDetails: false,
      clienteId: null,
      assinaturaId: null,
      qrCodeData: null,
      showPaymentConfirmationModal: false
    }
  },

  computed: {
    valorFinalCalculado() {
      if (!this.valorSelecionado) return 0;
      const valorNumerico = this.paymentOptionConfig?.value || 0;
      if (this.coupon.applied && this.coupon.discount > 0) {
        return valorNumerico - (valorNumerico * (this.coupon.discount / 100));
      }
      return valorNumerico;
    },
    valorFinalFormatado() {
      if (!this.valorSelecionado) return '';
      return `${this.valorFinalCalculado.toFixed(2).replace('.', ',')}`;
    },
    lastFourDigits() {
      if (!this.creditCard.number) return '';
      return this.creditCard.number.replace(/\s/g, '').slice(-4);
    },
    paymentOptionConfig() {
      const options = {
        plus_monthly: { value: 179.90, description: 'Plano Plus Mensal', annual: false },
        plus_yearly: { value: 1558.80, description: 'Plano Plus Anual a Vista', annual: true },
        plus_installment_2: { value: 779.40, description: 'Plano Plus Anual em 2x', annual: true },
        plus_installment_3: { value: 519.60, description: 'Plano Plus Anual em 3x', annual: true },
        plus_installment_4: { value: 389.70, description: 'Plano Plus Anual em 4x', annual: true },
        plus_installment_5: { value: 311.76, description: 'Plano Plus Anual em 5x', annual: true },
        plus_installment_6: { value: 259.80, description: 'Plano Plus Anual em 6x', annual: true },
        plus_installment_10: { value: 155.88, description: 'Plano Plus Anual em 10x', annual: true },
        plus_installment_12: { value: 129.90, description: 'Plano Plus Anual em 12x', annual: true }
      };
      return options[this.valorSelecionado] || null;
    },
    selectedOptionDescription() {
      return this.paymentOptionConfig?.description || '';
    }
  },

  methods: {
    onPhoneInput(e) {
      let val = e.target.value.replace(/\D/g, "");
      if (val.length > 11) val = val.slice(0, 11);
      if (val.length > 2 && val.length <= 6) val = `(${val.slice(0, 2)}) ${val.slice(2)}`;
      else if (val.length > 6) val = `(${val.slice(0, 2)}) ${val.slice(2, 3)} ${val.slice(3, 7)}-${val.slice(7)}`;
      else if (val.length > 0) val = `(${val}`;
      this.personalInfo.phone = val;
    },

    checkEmailPattern() {
      const email = this.personalInfo.email.toLowerCase();
      if ((email.endsWith("@gmail.com") || email.endsWith(".br")) && !this.hasShownContactModal) {
        this.showContactAlertModal = true;
        this.hasShownContactModal = true;
      }
    },

    validatePhoneField() { this.validation.phoneTouched = true; this.validation.phoneValid = !!this.personalInfo.phone; },
    validateEmailField() { 
      this.validation.emailTouched = true;
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      this.validation.emailValid = regex.test(this.personalInfo.email);
    },

    validateContactInfoBeforePayment() {
      this.validatePhoneField();
      this.validateEmailField();
      if (!this.validation.phoneValid || !this.validation.emailValid) {
        this.modalTitle = 'Verifique seus dados';
        this.modalMessage = 'Por favor, preencha corretamente o telefone e o e-mail.';
        this.showModal = true;
        return false;
      }
      return true;
    },

    handlePaymentOptionChange(event) {
      if (event.target.value !== '' && !this.validateContactInfoBeforePayment()) {
        this.valorSelecionado = '';
        return;
      }
      if (this.paymentMethod === 'pix') this.handleValorPixChange();
      else if (this.paymentMethod === 'boleto') this.handleValorBoletoChange();
    },

    async fetchAndPopulateCustomerData() {
      const doc = this.personalInfo.document.replace(/\D/g, '');
      if (doc.length !== 14 || this.isSubmittingData) return;
      this.isSubmittingData = true;
      this.showLoadingSpinner = true;
      try {
        const response = await fetch(`https://publica.cnpj.ws/cnpj/${doc}`);
        if (!response.ok) throw new Error('Falha na API');
        const data = await response.json();
        const est = data.estabelecimento;
        this.personalInfo.fullName = data.razao_social;
        this.billingAddress.street = `${est.tipo_logradouro || ''} ${est.logradouro || ''}`.trim();
        this.billingAddress.number = est.numero || 'S/N';
        this.billingAddress.zipCode = est.cep;
        this.billingAddress.city = est.cidade.nome;
        this.billingAddress.state = est.estado.sigla;
        this.billingAddress.bairro = est.bairro || '';
        this.billingAddress.complement = est.complemento || '';
        this.lastValidatedCnpj = doc;
      } catch (e) {
        console.error("CNPJ não encontrado", e);
      } finally {
        this.showLoadingSpinner = false;
        this.isSubmittingData = false;
      }
    },

    async createCustomerIfNeeded() {
      const doc = this.personalInfo.document.replace(/\D/g, '');
      if (!doc || doc.length < 11) return;
      try {
        const res = await apiClient.get(`/consultar-cliente/${doc}`);
        if (res.data && res.data.totalCount > 0) {
          this.clienteId = res.data.data[0].id;
        } else {
          this.clienteId = null;
        }
      } catch (error) {
        this.clienteId = null; // Cliente novo (404)
      }
    },

    async handleValorPixChange() {
      if (!this.valorSelecionado) return;
      this.showLoadingSpinner = true;
      this.loadingMessage = 'Gerando Pix Plano Plus...';
      try {
        await this.createCustomerIfNeeded();
        const payload = {
          customer: this.clienteId, 
          personalInfo: this.personalInfo,
          billingAddress: this.billingAddress,
          billingType: "PIX", 
          value: this.valorFinalCalculado, 
          paymentOptionId: this.valorSelecionado,
          selectedPlanName: 'plus'
        };
        const res = await apiClient.post('/criar-assinatura', payload);
        this.clienteId = res.data.customer; // Atualiza ID caso tenha sido criado agora
        this.assinaturaId = res.data.id;

        const cobrancaId = await this.aguardarCobrancaDisponivel();
        const qr = await apiClient.get(`/qrCode?cobranca=${cobrancaId}`);
        this.qrCodeData = qr.data;
        this.pixCode = qr.data.payload;
        this.showPixDetails = true;

        this.$nextTick(() => { this.atualizarInterfacePix(); });
        this.monitorPaymentStatus();
      } catch (e) { 
        console.error("Erro PIX Plus", e); 
      } finally { this.showLoadingSpinner = false; }
    },

    atualizarInterfacePix() {
      const canvas = document.getElementById('pix-qr');
      if (canvas && this.qrCodeData) {
        QRCode.toCanvas(canvas, this.qrCodeData.payload, { width: 200 });
      }
    },

    async handleValorBoletoChange() {
      if (!this.valorSelecionado) return;
      this.showLoadingSpinner = true;
      this.loadingMessage = 'Gerando Boleto Plano Plus...';
      try {
        await this.createCustomerIfNeeded();
        const payload = {
          customer: this.clienteId, 
          personalInfo: this.personalInfo,
          billingAddress: this.billingAddress,
          billingType: "BOLETO", 
          value: this.valorFinalCalculado, 
          paymentOptionId: this.valorSelecionado,
          selectedPlanName: 'plus'
        };
        const res = await apiClient.post('/criar-assinatura', payload);
        this.clienteId = res.data.customer; // Atualiza ID caso tenha sido criado agora
        
        const cobResponse = await apiClient.get(`/listarCobranca?customer=${this.clienteId}`);
        this.dados.linkFatura = cobResponse.data.invoiceUrl;
        this.showBoleto = true;
        this.monitorPaymentStatus();
      } catch (e) { console.error("Erro Boleto Plus", e); }
      finally { this.showLoadingSpinner = false; }
    },

    async aguardarCobrancaDisponivel() {
      const res = await apiClient.get(`/listarCobranca?customer=${this.clienteId}`);
      return res.data.id || res.data.data[0].id;
    },

    async monitorPaymentStatus() {
      if (this.paymentMonitorInterval) clearInterval(this.paymentMonitorInterval);
      this.monitorAttempts = 0;
      this.paymentMonitorInterval = setInterval(async () => {
        if (this.monitorAttempts >= this.maxMonitorAttempts) { clearInterval(this.paymentMonitorInterval); return; }
        try {
          const response = await apiClient.get(`/listarCobranca?customer=${this.clienteId}`);
          if (response.data && (response.data.status === 'RECEIVED' || response.data.status === 'CONFIRMED')) {
            clearInterval(this.paymentMonitorInterval);
            await this.sendToZarpon();
            this.currentStep = 3; 
            this.paymentSuccessful = true;
          }
        } catch (e) { console.error("Aguardando...", e); }
        this.monitorAttempts++;
      }, 3000);
    },

    async finalizeCreditCardPayment() {
      this.isProcessing = true;
      try {
        await this.createCustomerIfNeeded();
        const [m, a] = this.creditCard.expiryDate.split('/');
        const payload = {
          customer: this.clienteId,
          personalInfo: this.personalInfo,
          billingAddress: this.billingAddress,
          billingType: "CREDIT_CARD",
          value: this.valorFinalCalculado, 
          paymentOptionId: this.valorSelecionado,
          selectedPlanName: 'plus',
          creditCard: {
            holderName: this.creditCard.holderName,
            number: this.creditCard.number.replace(/\s/g, ''),
            expiryMonth: m,
            expiryYear: "20" + a, 
            ccv: this.creditCard.cvv
          },
          creditCardHolderInfo: {
            name: this.personalInfo.fullName,
            email: this.personalInfo.email,
            cpfCnpj: this.personalInfo.document.replace(/\D/g, ''),
            postalCode: this.billingAddress.zipCode.replace(/\D/g, ''),
            addressNumber: this.billingAddress.number,
            addressBairro: this.billingAddress.bairro,
            phone: this.personalInfo.phone.replace(/\D/g, '')
          }
        };
        await apiClient.post('/criar-assinatura-credcard', payload);
        await this.sendToZarpon();
        this.paymentSuccessful = true;
        this.currentStep = 3;
      } catch (error) {
        this.modalTitle = "Erro no Cartão";
        this.modalMessage = error.response?.data?.details || "Erro ao processar pagamento.";
        this.showModal = true;
      } finally { this.isProcessing = false; }
    },

    async sendToZarpon() {
      const isAnual = !!this.paymentOptionConfig?.annual;
      const webhookUrl = isAnual 
        ? 'https://beta.zarpon.com.br/webhooks/start/oNz0T1uGgGwbKR-F0A7JBw.WGVqLXkxam03ZEl3OEdJdw.U3P9sBRMOn2SRJvQdLw-2DfJe9ynYbtuU164Tn_3QS8'
        : 'https://beta.zarpon.com.br/webhooks/start/sbqubc4T-InHGxHHOSup8g.amRsUTlMbkI3TTdYaG9vNA.bMfn2ToOyqzLzGXgY1kl9uQvgstDRD0W2SMmrvuoDLQ';
      const data = {
        "lead": {
          "name": this.personalInfo.fullName,
          "phone": '55' + this.personalInfo.phone.replace(/\D/g, ''),
          "email": this.personalInfo.email,
          "variables": [{ "name": "plano", "content": "Plus" }, { "name": "tipo", "content": isAnual ? "Anual" : "Mensal" }]
        }
      };
      try { await fetch(webhookUrl, { method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(data) }); } 
      catch (e) { console.error("Erro Zarpon Plus", e); }
    },

    validateCoupon() {
      const code = this.coupon.code.trim().toUpperCase();
      const found = this.couponsList.find(c => c.cupon === code);
      if (found) {
        this.coupon.applied = true;
        this.coupon.discount = parseInt(found.percentual);
        alert("Cupom aplicado!");
      } else { alert("Cupom inválido."); }
    },

    showConfirmationModal() { this.showPaymentConfirmationModal = true; },
    cancelPayment() { this.showPaymentConfirmationModal = false; },
    confirmPayment() { this.showPaymentConfirmationModal = false; this.finalizeCreditCardPayment(); },
    nextStep() { this.currentStep++; },
    prevStep() { if(this.currentStep > 1) this.currentStep--; },
    toggleCoupon() { this.showCoupon = !this.showCoupon; },
    copyPixCode() { navigator.clipboard.writeText(this.pixCode); alert('Copiado!'); },
    closeModal() { if (this.paymentSuccessful) this.currentStep = 3; this.showModal = false; }
  },

  watch: {
    'creditCard.expiryDate'(val) {
        let cleaned = val.replace(/\D/g, '').slice(0, 4);
        if (cleaned.length > 2) cleaned = cleaned.slice(0, 2) + '/' + cleaned.slice(2);
        this.creditCard.expiryDate = cleaned;
    }
  }
}
</script>

<style scoped>
/* Estilos para o modal de confirmação de pagamento */
.payment-confirmation-modal {
  max-width: 500px;
  text-align: left;
}

.payment-details {
  margin: 20px 0;
  padding: 15px;
  background-color: #f9f9f9;
  border-radius: 8px;
  border-left: 4px solid #3E8DDD;
}

.detail-item {
  margin-bottom: 10px;
  padding: 8px 0;
  border-bottom: 1px solid #eee;
}

.detail-item:last-child {
  border-bottom: none;
  margin-bottom: 0;
}

.detail-item strong {
  color: #333;
  min-width: 150px;
  display: inline-block;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

.btn-secondary {
  background-color: #6c757d;
  border-color: #6c757d;
}

.btn-secondary:hover {
  background-color: #5a6268;
  border-color: #545b62;
}
</style>



<style scoped>

.input-invalid {
  border-color: #e74c3c !important; /* Borda vermelha */
  background-color: rgba(231, 76, 60, 0.08) !important; /* Fundo vermelho bem fraquinho */
}

/* Opcional: para o foco, manter o vermelho */
.input-invalid:focus {
  border-color: #c0392b !important;
  box-shadow: 0 0 0 0.2rem rgba(231, 76, 60, 0.25) !important;
}

/* Garanta que o estilo padrão do input ainda seja aplicado quando válido */
.form-input {
  /* Seus estilos padrão aqui */
  border: 1px solid #ccc; /* Exemplo de borda padrão */
  background-color: #fff; /* Exemplo de fundo padrão */
  padding: 10px;
  border-radius: 4px;
  width: 100%;
}

.boleto-container {
  max-width: 900px;
  margin: 0 auto;
  font-family: Arial, sans-serif;
  background-color: white;
  color: black;
}

.linha-digitavel {
  border: 2px solid black;
  padding: 8px;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 8px;
}

.boleto-box {
  border: 2px solid black;
}

.linha {
  display: flex;
  border-bottom: 1px solid black;
}

.linha:last-child {
  border-bottom: none;
}

.col {
  border-right: 1px solid black;
  padding: 6px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.col:last-child {
  border-right: none;
}

.col.grande {
  flex: 3;
}

.col.pequeno {
  flex: 1.2;
}

.col.logo {
  flex: 1;
  justify-content: center;
  align-items: center;
}

.col.numero {
  flex: 0.5;
  font-weight: bold;
  font-size: 18px;
  align-items: center;
}

.col.linha-digitavel-right {
  flex: 2;
  font-weight: bold;
  font-size: 14px;
  align-items: center;
}

.col.qrcode {
  flex: 1;
  justify-content: center;
  align-items: center;
}

.col.codigo-barras {
  flex: 3;
  justify-content: center;
  align-items: center;
}

.codigo-barras-texto {
  font-family: 'Libre Barcode 128', monospace;
  font-size: 40px;
}

.rotulo {
  font-size: 10px;
  color: gray;
}

a {
  color: blue;
  text-decoration: underline;
  font-size: 10px;
}


.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  padding: 25px 30px;
  border-radius: 8px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.2);
  width: 90%;
  max-width: 450px;
  text-align: center;
}

.modal-title {
  margin-top: 0;
  margin-bottom: 15px;
  font-size: 1.5rem;
  color: #333;
}

.modal-message {
  margin-bottom: 25px;
  font-size: 1rem;
  color: #555;
  white-space: pre-wrap; /* Para quebras de linha em mensagens de erro */
}

.modal-close-btn {
  background-color: #3E8DDD;
  color: white;
  border: none;
  padding: 10px 25px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: bold;
  transition: background-color 0.2s;
}

.modal-close-btn:hover {
  background-color: #3477bb;
}

/* NOVO: Estilo para botão desabilitado */
button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}



@media print {
  body {
    visibility: hidden;
  }

  .boleto-container {
    visibility: visible;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
  }
}

@keyframes toast-fadein {
  from { opacity: 0; transform: translate(-50%, -100%); }
  to { opacity: 1; transform: translate(-50%, -50%); }
}

@keyframes toast-fadeout {
  from { opacity: 1; transform: translate(-50%, -50%); }
  to { opacity: 0; transform: translate(-50%, -100%); }
}

/* Adicione ao seu arquivo CSS */
.form-input-size-4 {
  flex: 0 0 calc(33.333% - 10px) !important;
  max-width: calc(33.333% - 10px) !important;
}

.form-input-size-8 {
  flex: 0 0 calc(66.666% - 10px) !important;
  max-width: calc(66.666% - 10px) !important;
}

.disabled-field {
  background-color: #f5f5f5;
  color: #666;
  cursor: not-allowed;
}

.unlock-btn {
  margin-top: 15px;
  padding: 8px 15px;
  background-color: #f8f9fa;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
}

.unlock-btn:hover {
  background-color: #e9ecef;
}

.icone-svg {
 flex-shrink: 0; /* evita encolher */
  width: 24px;
  height: 24px;
  margin-right: 8px;
}

.icone {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.narrow-wizard {
  max-width: 800px;
  margin: 0 auto;
  padding: 0px;
}

.narrow-content {
  max-width: 800px;
  margin: 0 auto;
  padding: 0 15px;
}

.narrow-title {
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 15px;
  text-align: center;
}

.wizard {
  display: flex;
  justify-content: space-between;
}

.step {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.step-info {
  max-width: 200px;
}

.planos-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  font-family: Arial, sans-serif;
  position: relative;
  min-height: 100vh;
  padding-bottom: 60px;
  background-color: #fff; 
}

.logo-container {
  text-align: center;
  margin-bottom: 30px;
}

.logo {
  max-width: 350px;
  height: auto;
}

.wizard {
  display: flex;
  justify-content: space-between;
  margin-bottom: 40px;
  position: relative;
}

.wizard::before {
  content: '';
  position: absolute;
  top: 20px;
  left: 0;
  right: 0;
  height: 2px;
  background-color: #e0e0e0;
  z-index: 1;
}

.step {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 2;
  flex: 1;
}

.step-number {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #e0e0e0;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  font-weight: bold;
}

.step.active .step-number {
  background-color: #E4A64E;
}

.step-info {
  text-align: center;
  padding: 0 10px;
}

.step-title {
  font-weight: bold;
  margin-bottom: 5px;
}

.step-description {
  font-size: 0.9em;
  color: #666;
}

.step-content {
  background-color: #fff;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.step-content h2 {
  color: #333;
  margin-bottom: 10px;
}

.subtitle {
  color: #666;
  margin-bottom: 30px;
  text-align: center;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 15px;
}

.plans-container {
  display: flex;
  gap: 2rem;
  flex-wrap: wrap;
  justify-content: center;
}

.plan-card {
  flex: 1;
  min-width: 300px;
  max-width: 50%;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #e0e0e0;
  transition: transform 0.3s ease;
  display: flex;
  flex-direction: column;
  min-height: 600px;
}

.plan-card2 {
  flex: 1;
  min-width: 300px;
  max-width: 100%;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #e0e0e0;
  transition: transform 0.3s ease;
  display: flex;
  flex-direction: column;
}

.plan-card:hover {
  transform: translateY(-5px);
}

.plan-card.plus {
  border-top: 4px solid #E4A64E;
}

.plan-header {
  background-color: #E4A64E;
  color: white;
  padding: 20px;
  text-align: center;
}

.plan-sub {
  background-color: #ffffff;
  color: #000000;
  padding: 10px;
}

.plan-header h2 {
  margin: 0;
  color: #ffffff;
}

.plan-pricing {
  padding: 20px;
  text-align: center;
  border-bottom: 1px solid #e0e0e0;
}

.monthly, .yearly {
  margin-bottom: 15px;
}

.price {
  font-size: 1.8em;
  font-weight: bold;
  color: #333;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  line-height: 1;
}

.price::before {
  content: "R$";
  font-size: 0.6em;
  align-self: flex-start;
  margin-right: 4px;
  margin-top: 0.2em;
}

.period {
  color: #666;
  font-size: 0.9em;
}

.savings {
  background-color: #d9d8d6;
  border-radius: 6px;
  padding: 8px 12px;
  display: inline-block;
  margin-top: 10px;
  color: #000000;
  font-size: 0.9em;
}

.savings2 {
  background-color: #53b42f;
  border-radius: 6px;
  padding: 8px 12px;
  display: inline-block;
  margin-top: 10px;
  color: #ffffff;
  font-size: 0.9em;
}

.plan-features {
  padding: 20px;
  flex-grow: 1;
  gap: 12px; 
}

.feature {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
}

.feature i {
  color: #E4A64E;
  margin-right: 10px;
  font-size: 1.2em;
  vertical-align: middle;
}

.feature .menu-icon {
  color: #E4A64E;
  margin-right: 10px;
  width: 1.2em;
  height: 1.2em;
  stroke-width: 1.5;
}

.feature input[type="checkbox"] {
  margin-right: 10px;
}

.select-button {
  display: block;
  width: 100%;
  padding: 15px;
  background-color: #E4A64E;
  color: white;
  border: none;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s;
}

.select-button:hover {
  background-color: #E4A64E;
}

.navigation-buttons {
  display: flex;
  width: 100%;
  gap: 10px; 
  justify-content: space-between;
  margin-top: 30px;
}

.back-button, .next-button {
  padding: 10px 20px;
  border: none;
  border-radius: 30px;
  cursor: pointer;
  font-weight: bold;
}

.back-button {
  padding: 15px;
  background-color: #f1f1f1;
  color: #333;
}

.nav-button {
  flex: 1; /* Isso fará com que cada botão ocupe igual espaço */
  min-width: 0; /* Importante para evitar problemas de overflow */
  padding: 2px; /* Ajuste o padding conforme necessário */
  text-align: center;
}

.next-button {
  background-color: #E4A64E;
  color: white;
}

/* Estilos para o botão de voltar no topo */
.back-button-top {
  position: absolute;
  top: 20px;
  right: 20px;
}

.back-link {
  display: flex;
  align-items: center;
  gap: 5px;
  color: #E4A64E;
  text-decoration: none;
  font-weight: bold;
  padding: 8px 12px;
  border: 1px solid #E4A64E;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.back-link:hover {
  background-color: #E4A64E;
  color: white;
}

/* Estilos para o footer */
.site-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px;
  text-align: left;
  color: #666;
  font-size: 0.9em;
  border-top: 1px solid #e0e0e0;
}

/* Estilos para o botão do WhatsApp */
.whatsapp-button {
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 60px;
  height: 60px;
  background-color: #25D366;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  z-index: 1000;
}

.whatsapp-button i {
  color: white;
  font-size: 30px;
}

.pulse {
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

/* Estilos para o chat do WhatsApp */
.whatsapp-chat {
  position: fixed;
  bottom: 100px;
  right: 30px;
  width: 300px;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  z-index: 1001;
  overflow: hidden;
}

.chat-header {
  background-color: #075E54;
  color: white;
  padding: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.chat-header h3 {
  margin: 0;
  font-size: 16px;
}

.close-chat {
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  font-size: 18px;
}

.chat-body {
  padding: 15px;
}

.chat-body textarea {
  width: 100%;
  height: 100px;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 10px;
  resize: none;
}

.chat-footer {
  padding: 10px 15px;
  text-align: right;
  background-color: #f5f5f5;
}

.send-button {
  background-color: #25D366;
  color: white;
  border: none;
  padding: 8px 15px;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
} 

.send-button:hover {
  background-color: #128C7E;
}

.plan-name {
  background-color: #E4A64E;
  color: white;
  padding: 6px 12px;
  border-radius: 6px;
  display: inline-block;
  font-size: 14px;
  margin-bottom: 15px;
}

.collapse-item {
  border-bottom: 1px solid #eee;
  padding: 15px 0;
}

.collapse-item:last-child {
  border-bottom: none;
}

.collapse-header {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-weight: 500;
}

.collapse-icon {
  margin-left: 10px;
  transition: transform 0.3s;
}

.collapse-icon.expanded {
  transform: rotate(180deg);
}

.collapse-content {
  margin-top: 15px;
  padding-left: 20px;
}


.form-section {
  background: white;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 20px;
  width: 100%;
  box-sizing: border-box;
}

.form-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
  text-align: left;
  width: 100%;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  margin-bottom: 15px;
  width: 100%;
}

.form-group {
  flex: 1 1 100%;
  min-width: 0;
}

.form-label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  font-size: 14px;
  text-align: left;
}

.required {
  color: #dc3545;
}

.form-input, .form-select {
  width: 100%;
  padding: 12px 15px;
  border: 1px solid #ddd;
  border-radius: 38px;
  font-size: 14px;
  box-sizing: border-box;
}

.form-input:focus, .form-select:focus {
  outline: none;
  border-color: #E4A64E;
  box-shadow: 0 0 0 2px rgba(228, 166, 78, 0.1);
}

/* Estilos para desktop */
@media (min-width: 768px) {
  .form-row {
    flex-wrap: nowrap;
  }
  
  /* Campos que devem ocupar 1/3 da linha */
  .form-group.size-4 {
    flex: 0 0 calc(33.333% - 10px);
  }
  
  /* Campos que devem ocupar 2/3 da linha */
  .form-group.size-8 {
    flex: 0 0 calc(66.666% - 10px);
  }
  
  /* Campos de endereço em 3 colunas */
  .address-row .form-group {
    flex: 0 0 calc(33.333% - 10px);
  }
}

/* Estilo para campos desabilitados */
.disabled-field {
  background-color: #f5f5f5;
  color: #666;
  cursor: not-allowed;
}

.coupon-toast {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #FF6B00; /* Laranja */
  color: white;
  padding: 15px 30px;
  border-radius: 25px; /* Cantos arredondados */
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  text-align: center;
  opacity: 0;
  transition: all 0.3s ease;
  max-width: 80%;
}

.coupon-toast.show {
  opacity: 1;
  animation: slideIn 0.3s ease-out;
}

.coupon-toast.hide {
  opacity: 0;
  animation: slideOut 0.3s ease-in;
}

@keyframes slideIn {
  from {
    transform: translate(-50%, -100%);
    opacity: 0;
  }
  to {
    transform: translate(-50%, -50%);
    opacity: 1;
  }
}

@keyframes slideOut {
  from {
    transform: translate(-50%, -50%);
    opacity: 1;
  }
  to {
    transform: translate(-50%, -100%);
    opacity: 0;
  }
}

.payment-methods {
  display: flex;
  gap: 15px;
  margin-bottom: 20px;
}

.payment-method {
  flex: 1;
  padding: 8px;
  border: 2px solid #ddd;
  border-radius: 30px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s;
}

.payment-method.active {
  border-color: #E4A64E;
  background-color: #E4A64E;
  color: white;
}

.payment-method:hover {
  border-color: #E4A64E;
}

.coupon-input {
  display: flex;
  gap: 10px;
  align-items: end;
}

.coupon-input .form-group {
  flex: 1;
}

.btn {
  padding: 12px 24px;
  border: none;
  border-radius: 30px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s;
}

.btn-primary {
  background-color: #E4A64E;
  color: white;
}

.btn-primary:hover {
  background-color: #d6963e;
}

.btn-secondary {
  background-color: #6c757d;
  color: white;
}

.btn-secondary:hover {
  background-color: #5a6268;
}

.btn-outline {
  background-color: transparent;
  border: 1px solid #E4A64E;
  color: #E4A64E;
}

.btn-outline:hover {
  background-color: #E4A64E;
  color: white;
}

.finalize-btn {
  width: 100%;
  padding: 15px;
  font-size: 16px;
  margin-top: 20px;
}

.boleto-display, .pix-display {
  background: white;
  border-radius: 12px;
  padding: 24px;
  margin-top: 20px;
  text-align: center;
}

.boleto-header {
  border-bottom: 2px solid #333;
  padding-bottom: 10px;
  margin-bottom: 20px;
}

.boleto-info {
  text-align: left;
  margin: 20px 0;
}

.boleto-barcode {
  font-family: 'Courier New', monospace;
  font-size: 12px;
  letter-spacing: 1px;
  background-color: #f8f9fa;
  padding: 10px;
  border-radius: 4px;
  margin: 20px 0;
}

.qr-code {
  margin: 20px 0;
}

.pix-code {
  background-color: #f8f9fa;
  padding: 15px;
  border-radius: 8px;
  font-family: 'Courier New', monospace;
  font-size: 12px;
  word-break: break-all;
  margin: 20px 0;
}

.copy-btn {
  margin-top: 10px;
}

@media (max-width: 768px) {
  .form-row, .payment-methods {
    flex-direction: column;
  }
  
  .payment-method {
    width: 100%;
  }
}

@media (max-width: 768px) {
  .wizard {
    display: flex;
    flex-wrap: nowrap; /* Impede que os itens quebrem para nova linha */
    overflow-x: auto; /* Permite rolagem horizontal se necessário */
    gap: 5px; /* Espaço entre os steps */
    padding-bottom: 10px; 
  }

  .wizard::before {
    display: none;
  }

  .step {
    flex: 0 0 auto; /* Não permite que os itens cresçam ou encolham */
    width: 30%; /* Largura aproximada para 3 itens */
    min-width: 120px; /* Largura mínima para cada step */
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 5px;
  }

  .step-number {
    width: 30px;
    height: 30px;
    font-size: 14px;
    margin-bottom: 5px;
  }

  .step-info {
    text-align: center;
    padding: 0;

  }

  .step-title {
    font-size: 12px;
    margin-bottom: 2px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
  }
  
  .step-description {
    font-size: 10px;
    display: none; 
  }

  .wizard::-webkit-scrollbar {
    display: none;
  }
  
  .wizard {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }

  .plans-container {
    flex-direction: column;
  }

  .plan-card {
    max-width: 100%;
  }

  .whatsapp-chat {
    width: 280px;
    right: 10px;
  }
  
  .whatsapp-button {
    bottom: 20px;
    right: 20px;
    width: 50px;
    height: 50px;
  }
  
  .whatsapp-button i {
    font-size: 25px;
  }

  .back-button-top {
    position: static;
    text-align: right;
    margin-bottom: 15px;
    padding-right: 15px;
  }

  /* Estilo padrão (mobile-first) - campos em 100% */
.form-group-responsive {
  width: 100%;
}

/* Em desktop - campos com proporçÃµes 8 e 4 */
@media (min-width: 768px) {
  .form-group-size-4 {
    flex: 0 0 calc(33.333% - 10px) !important;
    max-width: calc(33.333% - 10px) !important;
  }

  .form-group-size-8 {
    flex: 0 0 calc(66.666% - 10px) !important;
    max-width: calc(66.666% - 10px) !important;
  }
}



}
</style>

